import React, { FC, useState } from 'react';
import './FooterLarge.scss';
import logo from './../../Assets/Images/cinderBuild-logo.png';
import { Link } from 'react-router-dom';
import footerImg from '../../Assets/Images/cb-footer-img.png';
import instagramIcon from '../../Assets/Images/icon/socials/instagram-logo.png';
import facebookIcon from '../../Assets/Images/icon/socials/facebook-logo.png';
import linkedinIcon from '../../Assets/Images/icon/socials/linkedIn-logo.png';
import xIcon from '../../Assets/Images/icon/socials/x-logo.png';

interface propsType {
  module?: string;
}

const FooterLarge: FC<propsType> = ({ module }) => {
  const [isActive, setActive] = useState<any>({ isActive: false, menu: 0 });

  const handleToggle = (data: any) => {
    setActive({ isActive: !isActive, ...data });
  };

  return (
    <React.Fragment>
      <footer
        className={
          module && module === 'estate'
            ? 'footer footer-estate fixed-footer'
            : 'footer fixed-footer'
        }
        id="footer"
      >
        <div className="container">
          <div className="row mt-3">
            <div
              className={
                isActive.isActive && isActive.menu === 1
                  ? 'col-sm-12 col-md-6 col-lg-6 widget active'
                  : 'col-sm-12 col-md-6 col-lg-6 widget'
              }
            >
              <img
                src={logo}
                alt="LOGO"
                className="footer-logo-item d-none d-md-block mb-2"
              />

              <h4
                onClick={() => handleToggle({ isActive: true, menu: 1 })}
                className={
                  isActive.isActive && isActive.menu === 1
                    ? 'footer-widget-title mb-3 active d-md-none'
                    : 'footer-widget-title mb-3 d-md-none'
                }
              >
                Contact Information
              </h4>

              <div className="widget_content footer-widget-content">
                <ul className="m-0 p-0 list-group">
                  <li className="list-group-item border-0 ps-0">
                    <div className="border-0 location-address">
                      16192 Coastal Highway, Lewes, Delaware, USA
                    </div>
                  </li>
                  <li className="list-group-item border-0 ps-0">
                    <div className="border-0 location-address pt-0 mt-0">
                      Vibranium Valley (Regus), 42 Concord Way, Local Airport
                      Road, Ikeja, Lagos.
                    </div>
                  </li>
                  <li className="list-group-item border-0 ps-0">
                    <div className="social-links d-flex align-items-center gap-3 mt-3">
                      <a
                        href="https://instagram.com"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={instagramIcon} alt="Instagram" />
                      </a>
                      <a
                        href="https://facebook.com"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={facebookIcon} alt="Facebook" />
                      </a>
                      <a
                        href="https://linkedin.com"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={linkedinIcon} alt="LinkedIn" />
                      </a>
                      <a
                        href="https://twitter.com"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={xIcon} alt="Twitter" />
                      </a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div
              className={
                isActive.isActive && isActive.menu === 3
                  ? 'col-sm-12 col-md-6 col-lg-2 widget active'
                  : 'col-sm-12 col-md-6 col-lg-2 widget'
              }
            >
              <h4
                onClick={() => handleToggle({ isActive: true, menu: 3 })}
                className={
                  isActive.isActive && isActive.menu === 3
                    ? 'footer-widget-title mb-3 active'
                    : 'footer-widget-title mb-3'
                }
              >
                Product
              </h4>

              <div className="widget_content footer-widget-content">
                <nav className="nav flex-column mb-3">
                  <a className="nav-link active" href="/">
                    Building Materials
                  </a>
                  <a className="nav-link" href="/">
                    Real Estate Projects
                  </a>
                  <a className="nav-link" href="/">
                    Project Financing
                  </a>
                </nav>
              </div>
            </div>

            <div
              className={
                isActive.isActive && isActive.menu === 2
                  ? 'col-sm-12 col-md-6 col-lg-2 widget active'
                  : 'col-sm-12 col-md-6 col-lg-2 widget'
              }
            >
              <h4
                onClick={() => handleToggle({ isActive: true, menu: 2 })}
                className={
                  isActive.isActive && isActive.menu === 2
                    ? 'footer-widget-title mb-3 active'
                    : 'footer-widget-title mb-3'
                }
              >
                Company
              </h4>

              <div className="widget_content footer-widget-content pb-5">
                <nav className="nav flex-column mb-3">
                  <Link className="nav-link" to="/about">
                    About us
                  </Link>
                  <Link className="nav-link" to="/about">
                    Contact us
                  </Link>
                  <Link className="nav-link" to="/about">
                    FAQs
                  </Link>
                </nav>
              </div>
            </div>

            <div
              className={
                isActive.isActive && isActive.menu === 4
                  ? 'col-sm-12 col-md-6 col-lg-2 widget active'
                  : 'col-sm-12 col-md-6 col-lg-2 widget'
              }
            >
              <h4
                onClick={() => handleToggle({ isActive: true, menu: 4 })}
                className={
                  isActive.isActive && isActive.menu === 4
                    ? 'footer-widget-title mb-3 active'
                    : 'footer-widget-title mb-3'
                }
              >
                Contact Us
              </h4>

              <div className="widget_content footer-widget-content">
                <nav className="nav flex-column mb-3">
                  <Link className="nav-link active" to="/">
                    cb_support@cinderbuild.com
                  </Link>
                  <Link className="nav-link" to="/">
                    09087792957
                  </Link>
                </nav>
              </div>
            </div>

            <div
              className={
                isActive.isActive && isActive.menu === 5
                  ? 'col-sm-12 col-md-6 col-lg-2 widget active d-none'
                  : 'col-sm-12 col-md-6 col-lg-2 widget d-none'
              }
            >
              <h4
                onClick={() => handleToggle({ isActive: true, menu: 5 })}
                className={
                  isActive.isActive && isActive.menu === 5
                    ? 'footer-widget-title mb-3 active'
                    : 'footer-widget-title mb-3'
                }
              >
                Resources
              </h4>

              <div className="widget_content footer-widget-content">
                <nav className="nav flex-column mb-3">
                  <a className="nav-link" href="#">
                    How to sell fast on CinderBuild
                  </a>
                  <a className="nav-link" href="#">
                    Learn how to post strategically and make the best sales on
                    CinderBuild
                  </a>
                  <a className="nav-link" href="#">
                    Top 10 best selling brands on CinderBuild
                  </a>
                </nav>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className="footer-credit text-center">
          <p>&copy; 2025 CinderBuild.com - All rights reserved.</p>
          <div className="footer-links d-flex gap-4">
            <Link className="nav-link" to="/privacy-policy">
              Privacy policy
            </Link>
            <Link className="nav-link" to="/terms-and-conditions">
              Terms & Conditions
            </Link>
          </div>
        </div>
        <div className="imgCon">
          <img src={footerImg} alt="footer" />
        </div>
      </footer>
    </React.Fragment>
  );
};

export default FooterLarge;
